import { MeetingProvider } from "@videosdk.live/react-sdk";
import { useEffect, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
// import { MeetingAppProvider } from "./MeetingAppContextDef";
import { MeetingContainer } from "./meeting/MeetingContainer";
import JoiningScreen from "./components/JoiningScreen";
import { useAppSelector } from "../store";
import { userData } from "../store/slices/user";
import useVideo from "../hooks/useVideo";
import { APP_PATH } from "../constants/routes";
import { STORAGE_KEY } from "../constants/video";
import Background from "../components/Background";
import Logo from "../components/Logo";
import useVideoStore from "./hooks/useVideoStore";

function Video() {
  const user = useAppSelector(userData);
  const {
    micOn,
    webcamOn,
    isMeetingStarted
  } = useVideoStore();
  const {
    fetchRoom, meetingId, appointmentId, token
  } = useVideo();
  const navigate = useNavigate();
  const [customAudioStream, setCustomAudioStream] = useState<MediaStream | undefined>(undefined);
  const [customVideoStream, setCustomVideoStream] = useState<MediaStream | undefined>(undefined);

  const isMobile = window.matchMedia(
    "only screen and (max-width: 768px)"
  ).matches;

  useEffect(() => {
    if (isMobile) {
      window.onbeforeunload = () => {
        return "Are you sure you want to exit?";
      };
    }
  }, [isMobile]);

  useEffect(() => {
    if (!appointmentId) {
      navigate(APP_PATH);
      // message.info("The meeting is expired");
    }

    if (!meetingId && appointmentId) {
      fetchRoom(appointmentId)
        .catch(() => {
          secureLocalStorage.removeItem(STORAGE_KEY);
        });
    }
  }, [meetingId, appointmentId]);

  useEffect(() => {
    return () => {
      if (!token && customAudioStream) {
        customAudioStream.getTracks().forEach((track) => track.stop());
      }
      if (!token && customVideoStream) {
        customVideoStream.getTracks().forEach((track) => track.stop());
      }
    };
  }, [token, customAudioStream, customVideoStream]);

  return (
    !meetingId && !appointmentId && !token ? <Spin spinning fullscreen /> : (
    // <MeetingAppProvider>
      <>
        <span style={{
          position: "absolute",
          top: "5vh",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 20
        }}
        >
          <Logo width={212} asLink={false} />
        </span>
        <Background step={5}/>
        <div style={{ position: "relative", zIndex: 10 }}>
          {isMeetingStarted ? (
            <MeetingProvider
              config={{
                meetingId: meetingId as string,
                micEnabled: micOn,
                webcamEnabled: webcamOn,
                name: user?.name ?? "TestUser",
                multiStream: true,
                customCameraVideoTrack: customVideoStream,
                customMicrophoneAudioTrack: customAudioStream,
                debugMode: false
              }}
              token={token as string}
              reinitialiseMeetingOnConfigChange
              joinWithoutUserInteraction
            >
              <MeetingContainer />
            </MeetingProvider>
          ) : (
            <JoiningScreen
              customAudioStream={customAudioStream}
              setCustomAudioStream={setCustomAudioStream}
              setCustomVideoStream={setCustomVideoStream}
            />
          )}
        </div>
      </>
    // </MeetingAppProvider>
    )
  );
}

export default Video;
